import React, { useState, useEffect } from 'react';

/**
 * 倒计时组件
 * @param currentTime 当前时间戳
 * @param expireTime 券过期时间戳
 */
const Countdown: React.FC<{ 
  currentTime: number; 
  expireTime: number; 
  onExpired?: () => void; // 过期回调
}> = ({ 
  currentTime, 
  expireTime, 
  onExpired
}) => {
  const [timeLeft, setTimeLeft] = useState<number>(0);

  useEffect(() => {
    if (!currentTime || !expireTime) return;

    const calculateTimeLeft = (baseTime: number) => {
      const diff = expireTime - baseTime;
      return Math.max(0, diff);
    };

    // 初始计算剩余时间
    const initialTimeLeft = calculateTimeLeft(currentTime);
    setTimeLeft(initialTimeLeft);

    // 如果初始就过期了，触发回调
    if (initialTimeLeft <= 0) {
      onExpired?.();
      return;
    }

    // 如果剩余时间小于24小时，需要实时更新倒计时
    const hoursLeft = initialTimeLeft / (1000 * 60 * 60);
    
    if (hoursLeft < 24 && hoursLeft > 0) {
      const timer = setInterval(() => {
        const now = Date.now();
        const diff = expireTime - now;
        const left = Math.max(0, diff);
        setTimeLeft(left);
        if (left <= 0) {
          clearInterval(timer);
          onExpired?.();
        }
      }, 1000);

      return () => clearInterval(timer);
    }
    // 对于 >= 24h 的情况，不需要更新，保持初始状态即可
  }, [currentTime, expireTime, onExpired]);

  // 格式化显示文本
  const formatDisplay = (): string => {
    if (timeLeft <= 0) return '';

    const hoursLeft = timeLeft / (1000 * 60 * 60);
    const daysLeft = timeLeft / (1000 * 60 * 60 * 24);

    // 剩余时间 < 24h: 显示倒计时 xx:xx:xx（0小时写为00:xx:xx）
    if (hoursLeft < 24) {
      const totalSeconds = Math.floor(timeLeft / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }
    
    // 24h < 剩余时间 < 72h: 展示 x天过期
    if (hoursLeft >= 24 && hoursLeft < 72) {
      const days = Math.floor(daysLeft);
      return `${days}天过期`;
    }
    
    // 72h <= 剩余时间: 展示 mm:dd过期
    const expireDate = new Date(expireTime);
    const month = String(expireDate.getMonth() + 1);
    const day = String(expireDate.getDate());
    return `${month}.${day}过期`;
  };

  if (!currentTime || !expireTime) return null;

  const displayText = formatDisplay();
  if (!displayText) return null;

  return <span>{displayText}</span>
  
};

export default Countdown;

